import React from 'react';
import { Dialog } from '@headlessui/react';

export default function ConfirmationPopup({
  title,
  message,
  isOpen,
  setIsOpen,
  onConfirm,
  confirmLabel = 'Confirm',
}: {
  title: string;
  message: string;
  isOpen: boolean;
  setIsOpen: (a: boolean) => void;
  onConfirm: () => void;
  confirmLabel?: string;
}) {
  return (
    <Dialog open={isOpen} onClose={() => setIsOpen(false)} className="z-500 relative">
      <div className="fixed inset-0 flex items-center justify-center bg-slate-900 bg-opacity-60 p-4">
        <Dialog.Panel className="min-w-[300px] rounded bg-white px-10 py-5">
          <Dialog.Title className="mb-5 text-xl capitalize">{title}</Dialog.Title>
          <Dialog.Description className="text-lg">{message}</Dialog.Description>

          <div className="mt-10 flex justify-between">
            <button onClick={() => setIsOpen(false)} className="">
              Cancel
            </button>
            <button
              onClick={() => {
                onConfirm();
                setIsOpen(false);
              }}
              className="btn-primary">
              {confirmLabel}
            </button>
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
}
